import {  css } from 'aphrodite';
import { PieChart, Pie, Sector, Cell, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar} from 'recharts';
import * as React from 'react';
import Faculty from 'src/models/Faculty.js';
import { getFacultyStats } from 'src/core/api';
import { getRandomColor } from 'src/views/Utils';
import { Card, CardHeader, ListGroup, ListGroupItem, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';
import {styles} from "src/styles/DepartmentPage";
import { HorizontalAxisTick, VerticalAxisTick } from 'src/components/charts/AxisTick';


interface IDepartmentPageProps {
    history: any
}

const barHeight: number = 50;

class FacultyItem {

    public readonly id : number;
    public readonly name: string;
    public readonly count: number
    public readonly color: any

    constructor(id: number,name: string,count: number, color: any) {
        this.id = id
        this.name = name
        this.count = count
        this.color = color
    }
}

enum ChartOptions {
    BAR,
    PIE
}

enum SortingOptions {
    ASCENDING,
    DESCENDING
}

class DepartmentPageState {
    public readonly data : FacultyItem[]
    public readonly activeIndex: number
    public selectedChart: ChartOptions;
    public readonly isDropDownOpen: boolean;
    public readonly selectedSorting: SortingOptions;

    
    constructor(){
        this.data = getFacultyStats().map((faculty: Faculty) => {
            return new FacultyItem(
                faculty.id,
                faculty.name,
                faculty.count,
                getRandomColor()
            )
        });
        this.activeIndex = 0
        this.selectedChart = ChartOptions.PIE,
        this.selectedSorting = SortingOptions.DESCENDING;
    }
}


class DepartmentPage extends React.Component<IDepartmentPageProps,DepartmentPageState> {

    constructor(props: IDepartmentPageProps) {
        super(props)
        this.state = new DepartmentPageState();
    }

    public render() {

        let chartContainerStyle;

        let chart;

        if(this.state.selectedChart === ChartOptions.BAR){
            chartContainerStyle = styles.bar_chart_container
            chart = (
                <div className={css(styles.chartContainer)} >
                    <Card height={550} className={css(styles.barChartCard)} >
                        <CardHeader className={css(styles.barChartCardHeader)}>
                            <div className={css(styles.barChartOptionsContainer)} >
                                <div className={css(styles.barChartOptions)} >
                                    <UncontrolledDropdown >
                                        <DropdownToggle caret={true}>
                                                {this.getSortingLabel()}
                                            </DropdownToggle>
                                            <DropdownMenu >
                                                <DropdownItem onClick={ (event:any) => this.onSortingOptionSelected(SortingOptions.ASCENDING)}>Ascending</DropdownItem>
                                                <DropdownItem onClick={ (event:any) => this.onSortingOptionSelected(SortingOptions.DESCENDING)}>Descending</DropdownItem>
                                            </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        
                        </CardHeader>

                        <div className={css(styles.barChart)} >
                            <BarChart 
                                    width={1000}
                                    height={this.getHeight()}
                                    layout="vertical" data={this.getBarChartData()}
                                    margin={{top: 5, right: 0, left: 0, bottom: 5}}
                                    >
                                <CartesianGrid strokeDasharray="3 3" horizontal={false}/> 
                                <XAxis type="number" axisLine={false} tick={<HorizontalAxisTick fontSize={12}/> }  />
                                <YAxis type="category" dataKey="name" axisLine={false} hide={false} interval={0} width={100}
                                        tick={<VerticalAxisTick fontSize={11}/>} 
                                />
                                <Tooltip cursor={false} payload={
                                    this.state.data.map((entry,_index)=>{
                                        return {
                                            name: "hello",
                                            value: entry.count,
                                            unit: ""
                                        }
                                    })
                                }/>     
                                                                                                        
                                <Bar dataKey="count" barSize={15} onClick={this.onChartItemClick}  >
                                    {
                                        this.state.data.map(this.buildHorizontalBar)
                                    }
                                </Bar>
                            </BarChart>
                        </div>
                    </Card>
                </div>
                );
        }else{
            chartContainerStyle = styles.pie_chart_container
            chart = (
                <PieChart 
                        width={1000}
                        height={550}
                        className={css(styles.chart)}
                        >
                        <Pie 
                            activeIndex={this.state.activeIndex}
                            activeShape={renderActiveShape} 
                            data={this.state.data} 
                            innerRadius={100}
                            outerRadius={180} 
                            fill="#8884d8"
                            label={renderLabel}
                            labelLine={false}
                            nameKey={"name"}
                            dataKey={"count"}
                            onMouseEnter={this.onPieEnter}
                            onClick={this.onChartItemClick}
                        >
                            {
                               this.state.data.map((entry, index) => <Cell fill={entry.color} key={index} />)
                            } 
                        </Pie>
                    </PieChart>
            );
        }

        return (
            <div id="content" className={css(styles.content)} >
                
                <div className={css(styles.titleContainer)} >
                    <div id="title" className={css(styles.title)}>
                        Distribution of awards by faculty
                    </div>
                
                    <UncontrolledDropdown >
                        <DropdownToggle caret={true}>
                                {this.getChartLabel()}
                            </DropdownToggle>
                            <DropdownMenu >
                                <DropdownItem onClick={ (event:any) => this.onChartOptionSelected(ChartOptions.PIE)}>PIE</DropdownItem>
                                <DropdownItem onClick={ (event:any) => this.onChartOptionSelected(ChartOptions.BAR)}>BAR</DropdownItem>
                            </DropdownMenu>
                    </UncontrolledDropdown>
                </div>

                

                <div>

                </div>

                <div id="chart_container" className={css(chartContainerStyle)} >
                    
                    <div className={css(styles.legendContainer)} >
                        <Card id="legend" className={css(styles.legendCard)} >
                            <CardHeader>
                                Total :  $ {this.getTotoal(this.state.data)}
                            </CardHeader>
                            <ListGroup flush={true} className={css(styles.legends)} >
                                    {
                                        this.state.data.map(this.renderLegendItem)
                                    }
                            </ListGroup>
                        </Card>     
                    </div>

                    {chart}

                </div>
                   
                                
            </div>
        )      
    }

    private buildHorizontalBar = (entry: any,index: number) => {
        const fill = entry.color
        return(
            <Cell cursor="pointer" fill={fill}  key={`cell-${index}`} height={barHeight-10} />
        );
    }

    private getSortingLabel = () => {
        if(this.state.selectedSorting === SortingOptions.DESCENDING){
            return "Descending";
        }else{
            return "Ascending";
        }
    }

    private onSortingOptionSelected = (event: SortingOptions) => {
        this.setState({...this.state, selectedSorting: event})
    }

    private getChartLabel = () => {
        if(this.state.selectedChart === ChartOptions.BAR){
            return "BAR";
        }else{
            return "PIE";
        }
    }

    private onChartOptionSelected = (event: ChartOptions) => {
        this.setState({...this.state, selectedChart: event})
    }

    private getHeight = () => {
        if(this.state.data.length !== 0){
            return this.state.data.length * barHeight;
        }else{
            return 500;
        }
    }

    private getTotoal = (data: FacultyItem[]) => {
        let total = 0;
        for (const faculty of data){
            total = total + faculty.count;
        }
        return total;
    }
    
    private onPieEnter = (data: any, index: number) => {
        this.setState({
            activeIndex: index,
        });
    }
    
    private onChartItemClick = (data: any, index: number) => {
        const faculty = this.state.data[index];
        const faculty_id = 8084702300;
        this.props.history.push("/faculty/" + faculty_id);
    }

    private renderLegendItem = (faculty: FacultyItem,index: number) => {
        return (
        <ListGroupItem>
            <div id="legend_item" className={css(styles.legendItem)}
                                      onMouseEnter={this.onLegendHover(index)}
                                      onClick={this.onLegendClick(index)} 
                                      key={index}>
                <div style={{
                    width: 30,
                    height: 30,
                    backgroundColor: faculty.color,
                    marginRight:10
                }}/>

                <div style={{
                    fontSize:16,
                    color:"gray"
                }}>
                    {faculty.name}
                </div>

            </div>
        </ListGroupItem>
        );
    }
    
    private onLegendHover = (index: number) => (event: any) => {
        console.log(index)
        this.setState({
            activeIndex: index
        })
    }

    private onLegendClick = (index: number) => (event: any) => {
        const faculty = this.state.data[index];
        const faculty_id = 8084702300;
        this.props.history.push("/faculty/" + faculty_id);
    }
    
    private getBarChartData = () => {
        const newList = Object.assign([],this.state.data);
        if(this.state.selectedSorting === SortingOptions.ASCENDING){
            newList.sort((item1: FacultyItem, item2: FacultyItem) => {
                return item1.count - item2.count; 
            })
        }else{
            newList.sort((item1: FacultyItem, item2: FacultyItem) => {
                return item2.count - item1.count; 
            })
        }
        return newList;
    } 

}

const renderLabel = (props: any) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, outerRadius,
      fill, payload, percent } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 50) * cos;
    const my = cy + (outerRadius + 60) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
  
    return (
      <g className={css(styles.hover)} >
        
        
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name} (${(percent * 100).toFixed(2)}%)`}</text>
      </g>
    );
};
  

const renderActiveShape = (props: any) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
      fill, payload, percent } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 50) * cos;
    const my = cy + (outerRadius + 60) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
  
    return (
      <g className={css(styles.hover)} >
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>{payload.name}</text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name} (${(percent * 100).toFixed(2)}%)`}</text>
      </g>
    );
};



export default DepartmentPage;


// WEBPACK FOOTER //
// ./src/pages/DepartmentPage.tsx